'use strict';

require('./daterangepicker++.js');
require('./angular-daterangepicker++.js');
module.exports = 'angular-custom-daterangepicker';


//////////////////
// WEBPACK FOOTER
// ./src/modules/angular-custom-daterangepicker/index.js
// module id = 201
// module chunks = 1 2